// frontend/src/components/shared/Footer.tsx

import { ArrowUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useApp } from '@/context/AppContext';
import { cn } from '@/lib/utils';
import { AppVersion } from './AppVersion';

export function Footer({ className }: React.HTMLAttributes<HTMLElement>) {
  const { name } = useApp();
  const scrollToTop = () => {
    const mainContent = document.getElementById('main-content-area');
    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer
      className={cn(
        // Mobile: Stacked column layout
        'w-full flex flex-col items-center gap-4 py-4 px-4',
        // Desktop: Row layout with items spaced apart
        'sm:h-16 sm:flex-row sm:items-center sm:justify-between sm:py-0 sm:px-6 lg:px-8',
        className
      )}
    >
      <div className="flex flex-col items-center gap-1 text-sm text-muted-foreground sm:flex-row sm:gap-x-2">
        <span>
          {name} © {new Date().getFullYear()}
        </span>
        <span aria-hidden="true" className="hidden sm:inline-block">
          •
        </span>
        <AppVersion />
      </div>

      <Button variant="link" className="text-muted-foreground" onClick={scrollToTop}>
        <ArrowUp className="mr-2 h-4 w-4" />
        Back to Top
      </Button>
    </footer>
  );
}
